"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionMode = void 0;
var Loader_1 = require("../Loader");
var util_1 = require("../util");
var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["BRUTE_FORCE"] = 0] = "BRUTE_FORCE";
    SelectionMode[SelectionMode["BIGGER_FIRST"] = 1] = "BIGGER_FIRST";
    // RANDOM,
})(SelectionMode || (exports.SelectionMode = SelectionMode = {}));
function mergeOutputsAmounts(outputs) {
    var compiledAmountList = Loader_1.default.CSL.Value.new(Loader_1.default.CSL.BigNum.from_str("0"));
    for (var i = 0; i < outputs.len(); ++i) {
        compiledAmountList = compiledAmountList.checked_add(outputs.get(i).amount());
    }
    return compiledAmountList;
}
function splitAmounts(amounts) {
    var splitAmounts = [];
    var mA = amounts.multiasset();
    if (mA) {
        var scriptHashes = mA.keys();
        for (var i = 0; i < scriptHashes.len(); ++i) {
            var scriptHash = scriptHashes.get(i);
            var assets = mA.get(scriptHash);
            if (assets) {
                var assetNames = assets.keys();
                for (var j = 0; j < assetNames.len(); ++j) {
                    var assetName = assetNames.get(j);
                    var amount = assets.get(assetName);
                    if (amount) {
                        var _assets = Loader_1.default.CSL.Assets.new();
                        _assets.insert(Loader_1.default.CSL.AssetName.from_bytes(assetName.to_bytes()), Loader_1.default.CSL.BigNum.from_bytes(amount.to_bytes()));
                        var _multiasset = Loader_1.default.CSL.MultiAsset.new();
                        _multiasset.insert(Loader_1.default.CSL.ScriptHash.from_bytes(scriptHash.to_bytes()), _assets);
                        var _value = Loader_1.default.CSL.Value.new(Loader_1.default.CSL.BigNum.from_str("0"));
                        _value.set_multiasset(_multiasset);
                        splitAmounts.push(_value);
                    }
                }
            }
        }
    }
    // TODO: think about it
    // Order assets by qty DESC
    // splitAmounts = sortAmountList(splitAmounts, "DESC");
    // Insure lovelace is last to account for min ada requirement
    splitAmounts.push(Loader_1.default.CSL.Value.new(Loader_1.default.CSL.BigNum.from_bytes(amounts.coin().to_bytes())));
    return splitAmounts;
}
function compareCoins(leftValue, rightValue) {
    return leftValue.coin().compare(rightValue.coin());
}
function compareMultiAssets(leftValue, rightValue) {
    var lma = leftValue.multiasset();
    var rma = rightValue.multiasset();
    if (!lma || !rma) {
        return undefined;
    }
    var res = undefined;
    var scriptHashes = lma.keys();
    for (var i = 0; i < scriptHashes.len(); ++i) {
        var scriptHash = scriptHashes.get(i);
        var leftAssets = lma.get(scriptHash);
        var rightAssets = rma.get(scriptHash);
        if (!leftAssets || !rightAssets) {
            return undefined;
        }
        var lans = leftAssets.keys();
        for (var j = 0; j < lans.len(); ++j) {
            var assetName = lans.get(j);
            var leftAmount = leftAssets.get(assetName);
            var rightAmount = rightAssets.get(assetName);
            if (!leftAmount || !rightAmount) {
                return undefined;
            }
            res = leftAmount.compare(rightAmount);
        }
    }
    return res;
}
function sortByCoin(elems) {
    if (elems.length === 0) {
        return [];
    }
    var res = [elems[0]];
    for (var i = 1; i < elems.length; ++i) {
        var amount = elems[i].output().amount().coin();
        var j = 0;
        for (; j < res.length; ++j) {
            var otherAmount = res[j].output().amount().coin();
            if (amount.compare(otherAmount) >= 0) {
                break;
            }
        }
        if (j < res.length) {
            res = __spreadArray(__spreadArray(__spreadArray([], res.slice(0, j), true), [elems[i]], false), res.slice(j), true);
        }
        else {
            res.push(elems[i]);
        }
    }
    return res;
}
function getAmountOfMultiAsset(value, scriptHash, assetName) {
    var multiAsset = value.multiasset();
    if (multiAsset) {
        var assets = multiAsset.get(scriptHash);
        if (assets) {
            return assets.get(assetName);
        }
    }
    return undefined;
}
function sortByMultiAsset(elems, scriptHash, assetName) {
    if (elems.length === 0) {
        return [];
    }
    var res = [elems[0]];
    for (var i = 1; i < elems.length; ++i) {
        var amount = getAmountOfMultiAsset(elems[i].output().amount(), scriptHash, assetName);
        if (!amount) {
            res.push(elems[i]);
        }
        else {
            var j = 0;
            for (; j < res.length; ++j) {
                var otherAmount = getAmountOfMultiAsset(res[j].output().amount(), scriptHash, assetName);
                if (!otherAmount || amount.compare(otherAmount) >= 0) {
                    break;
                }
            }
            if (j < res.length) {
                res = __spreadArray(__spreadArray(__spreadArray([], res.slice(0, j), true), [elems[i]], false), res.slice(j), true);
            }
            else {
                res.push(elems[i]);
            }
        }
    }
    return res;
}
var CoinSelection = /** @class */ (function () {
    function CoinSelection() {
    }
    CoinSelection.prototype.setProtocolParameters = function (minUTxO, minFeeA, minFeeB, maxTxSize, coinsPerUtxoByte) {
        this.protocolParameters = {
            minUTxO: minUTxO,
            minFeeA: minFeeA,
            minFeeB: minFeeB,
            maxTxSize: maxTxSize,
            coinsPerUtxoByte: coinsPerUtxoByte
        };
        // console.log(this.protocolParameters);
    };
    CoinSelection.prototype.findPossibleMax = function (unit_1, inputs_1) {
        return __awaiter(this, arguments, void 0, function (unit, inputs, limit) {
            var selection, amount, index, scriptHash, assetName, sortedInputs, _i, sortedInputs_1, input, addAmount, sortedInputs, _a, sortedInputs_2, input, addAmount;
            if (limit === void 0) { limit = 30; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.protocolParameters) {
                            throw new Error("Protocol parameters not set. Use setProtocolParameters().");
                        }
                        return [4 /*yield*/, Loader_1.default.load()];
                    case 1:
                        _b.sent();
                        selection = [];
                        amount = Loader_1.default.CSL.BigNum.from_str("0");
                        if (unit !== "lovelace") {
                            index = unit.indexOf('.');
                            scriptHash = Loader_1.default.CSL.ScriptHash.from_bytes((0, util_1.HexToBuffer)(unit.slice(0, index)));
                            assetName = Loader_1.default.CSL.AssetName.new((0, util_1.HexToBuffer)((0, util_1.AsciiToHex)(unit.slice(index + 1))));
                            sortedInputs = sortByMultiAsset(inputs, scriptHash, assetName);
                            for (_i = 0, sortedInputs_1 = sortedInputs; _i < sortedInputs_1.length; _i++) {
                                input = sortedInputs_1[_i];
                                addAmount = getAmountOfMultiAsset(input.output().amount(), scriptHash, assetName);
                                if (addAmount === undefined) {
                                    break;
                                }
                                amount = amount.checked_add(addAmount);
                                selection.push(input);
                                if (selection.length >= limit) {
                                    break;
                                }
                            }
                        }
                        else {
                            sortedInputs = sortByCoin(inputs);
                            for (_a = 0, sortedInputs_2 = sortedInputs; _a < sortedInputs_2.length; _a++) {
                                input = sortedInputs_2[_a];
                                addAmount = input.output().amount().coin();
                                amount = amount.checked_add(addAmount);
                                selection.push(input);
                                if (selection.length >= limit) {
                                    break;
                                }
                            }
                        }
                        return [2 /*return*/, {
                                amount: amount.to_str(),
                                selection: selection
                            }];
                }
            });
        });
    };
    CoinSelection.prototype.select = function (inputs_1, outputs_1) {
        return __awaiter(this, arguments, void 0, function (inputs, outputs, fee, limit, mode) {
            var dataCost, utxoSelection, mergedOutputsAmounts, maxFee, splitedOutputsAmounts, txOutputBuilder, txOutputAmountBuilder, amountRemaining, minAda;
            if (fee === void 0) { fee = undefined; }
            if (limit === void 0) { limit = 30; }
            if (mode === void 0) { mode = SelectionMode.BIGGER_FIRST; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.protocolParameters) {
                            throw new Error("Protocol parameters not set. Use setProtocolParameters().");
                        }
                        return [4 /*yield*/, Loader_1.default.load()];
                    case 1:
                        _a.sent();
                        dataCost = Loader_1.default.CSL.DataCost.new_coins_per_byte(Loader_1.default.CSL.BigNum.from_str(this.protocolParameters.coinsPerUtxoByte));
                        utxoSelection = {
                            selection: [],
                            remaining: __spreadArray([], inputs, true), // Shallow copy
                            subset: [],
                            amount: Loader_1.default.CSL.Value.new(Loader_1.default.CSL.BigNum.from_str("0")),
                        };
                        mergedOutputsAmounts = mergeOutputsAmounts(outputs);
                        maxFee = Loader_1.default.CSL.Value.new(fee
                            ? Loader_1.default.CSL.BigNum.from_str(fee)
                            : Loader_1.default.CSL.BigNum.from_str(this.protocolParameters.minFeeA).checked_mul(Loader_1.default.CSL.BigNum.from_str(this.protocolParameters.maxTxSize)).checked_add(Loader_1.default.CSL.BigNum.from_str(this.protocolParameters.minFeeB)));
                        mergedOutputsAmounts = mergedOutputsAmounts.checked_add(maxFee);
                        splitedOutputsAmounts = splitAmounts(mergedOutputsAmounts);
                        splitedOutputsAmounts.slice(0, -1).forEach(function (output) {
                            var _a;
                            var scriptHash;
                            var assetName;
                            var multiAsset = output.multiasset();
                            if (multiAsset) {
                                var scriptHashes = multiAsset.keys();
                                if (scriptHashes.len() === 1) {
                                    scriptHash = scriptHashes.get(0);
                                    var assets = multiAsset.get(scriptHash);
                                    if (assets) {
                                        var assetNames = assets.keys();
                                        if (assetNames.len() === 1) {
                                            assetName = assetNames.get(0);
                                        }
                                    }
                                }
                            }
                            if (!scriptHash || !assetName) {
                                throw new Error("UKNOWN_ASSET");
                            }
                            var remaining;
                            switch (mode) {
                                case SelectionMode.BRUTE_FORCE:
                                    remaining = __spreadArray([], utxoSelection.remaining, true);
                                    break;
                                case SelectionMode.BIGGER_FIRST:
                                default:
                                    remaining = sortByMultiAsset(utxoSelection.remaining, scriptHash, assetName);
                                    break;
                            }
                            utxoSelection.remaining = [];
                            for (var i = 0; i < remaining.length; ++i) {
                                var val = remaining[i].output().amount();
                                var comparisonMultiAssets_1 = compareMultiAssets(output, utxoSelection.amount);
                                if (comparisonMultiAssets_1 === undefined || comparisonMultiAssets_1 > 0) {
                                    if (compareMultiAssets(output, val) !== undefined) {
                                        utxoSelection.selection.push(remaining[i]);
                                        utxoSelection.amount = utxoSelection.amount.checked_add(val);
                                    }
                                    else {
                                        utxoSelection.remaining.push(remaining[i]);
                                    }
                                }
                                else {
                                    (_a = utxoSelection.remaining).push.apply(_a, remaining.slice(i));
                                    break;
                                }
                            }
                            var comparisonMultiAssets = compareMultiAssets(output, utxoSelection.amount);
                            if (comparisonMultiAssets === undefined || comparisonMultiAssets > 0) {
                                throw new Error("BALANCE_EXHAUSTED");
                            }
                        });
                        splitedOutputsAmounts.slice(-1).forEach(function (output) {
                            var _a;
                            var remaining;
                            switch (mode) {
                                case SelectionMode.BRUTE_FORCE:
                                    remaining = __spreadArray([], utxoSelection.remaining.reverse(), true);
                                    break;
                                case SelectionMode.BIGGER_FIRST:
                                default:
                                    remaining = sortByCoin(utxoSelection.remaining);
                                    break;
                            }
                            utxoSelection.remaining = [];
                            for (var i = 0; i < remaining.length; ++i) {
                                var val = remaining[i].output().amount();
                                var comparisonCoins_1 = compareCoins(output, utxoSelection.amount);
                                if (comparisonCoins_1 === undefined || comparisonCoins_1 > 0) {
                                    if (compareCoins(output, val) !== undefined) {
                                        utxoSelection.selection.push(remaining[i]);
                                        utxoSelection.amount = utxoSelection.amount.checked_add(val);
                                    }
                                    else {
                                        utxoSelection.remaining.push(remaining[i]);
                                    }
                                }
                                else {
                                    (_a = utxoSelection.remaining).push.apply(_a, remaining.slice(i));
                                    break;
                                }
                            }
                            var comparisonCoins = compareCoins(output, utxoSelection.amount);
                            if (comparisonCoins === undefined || comparisonCoins > 0) {
                                throw new Error("BALANCE_EXHAUSTED");
                            }
                        });
                        do {
                            txOutputBuilder = Loader_1.default.CSL.TransactionOutputBuilder
                                .new()
                                .with_address(inputs[0].output().address());
                            txOutputAmountBuilder = txOutputBuilder.next();
                            amountRemaining = utxoSelection.amount.checked_sub(mergedOutputsAmounts);
                            minAda = Loader_1.default.CSL.min_ada_for_output(txOutputAmountBuilder
                                .with_value(amountRemaining)
                                .build(), dataCost);
                            // console.log(amountRemaining.coin().to_str(), minAda.to_str());
                            if (Loader_1.default.CSL.BigNum.from_str(amountRemaining.coin().to_str()).compare(minAda) < 0) {
                                if (utxoSelection.remaining.length === 0) {
                                    throw new Error("BALANCE_EXHAUSTED");
                                }
                                utxoSelection.selection.push(utxoSelection.remaining[0]);
                                utxoSelection.amount = utxoSelection.amount.checked_add(utxoSelection.remaining[0].output().amount());
                                utxoSelection.remaining = __spreadArray([], utxoSelection.remaining.slice(1), true);
                            }
                            else {
                                break;
                            }
                        } while (true);
                        if (utxoSelection.selection.length > limit) {
                            throw new Error("INPUT_LIMIT_EXCEEDED");
                        }
                        // TODO: develop it
                        // Phase 1: RandomSelect
                        // Phase 2: Improve
                        // console.log((utxoSelection.amount).coin().to_str());
                        // console.log((utxoSelection.amount.checked_sub(mergedOutputsAmounts)).coin().to_str());
                        return [2 /*return*/, {
                                input: utxoSelection.selection,
                                remaining: utxoSelection.remaining,
                                reamainingValue: utxoSelection.amount.checked_add(maxFee).checked_sub(mergedOutputsAmounts)
                            }];
                }
            });
        });
    };
    return CoinSelection;
}());
exports.default = CoinSelection;
function createSubSet(utxoSelection, output) {
    if (Number(output.coin().to_str()) < 1) {
        utxoSelection.remaining.forEach(function (utxo, index) {
            if (output.compare(utxo.output().amount()) !== undefined) {
                utxoSelection.subset.push(utxoSelection.remaining.splice(index, 1).pop());
            }
        });
    }
    else {
        utxoSelection.subset = utxoSelection.remaining.splice(0, utxoSelection.remaining.length);
    }
}
